var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1.5rem",
    height: "1.5rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M464 80H48a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h416a32 32 0 0 0 32-32V112a32 32 0 0 0-32-32m0 32v48H48v-48ZM48 368V208h416v160Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80 304h96v32H80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.44dbc65c6bec84dee026b74e8ec21a86.svg";
export { ForwardRef as ReactComponent };